import { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { lazyWithChunkReload } from '@/shared/utils/lazyWithChunkReload';
import { Providers } from './Providers';
import { Layout } from './Layout';
import { PageLoader } from './PageLoader';
import { RequireWallet } from '@/shared/components/RequireWallet';

const HomePage = lazyWithChunkReload(() =>
  import('./pages/HomePage').then((m) => ({ default: m.HomePage })),
);
const SchedulesPage = lazyWithChunkReload(() =>
  import('./pages/SchedulesPage').then((m) => ({ default: m.SchedulesPage })),
);
const CreateSchedulePage = lazyWithChunkReload(() =>
  import('./pages/CreateSchedulePage').then((m) => ({ default: m.CreateSchedulePage })),
);
const HistoryPage = lazyWithChunkReload(() =>
  import('./pages/HistoryPage').then((m) => ({ default: m.HistoryPage })),
);

export function App() {
  return (
    <Providers>
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/schedules" element={<RequireWallet><SchedulesPage /></RequireWallet>} />
              <Route path="/create" element={<RequireWallet><CreateSchedulePage /></RequireWallet>} />
              <Route path="/history" element={<RequireWallet><HistoryPage /></RequireWallet>} />
              <Route path="/interest" element={<Navigate to="/schedules" replace />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </Providers>
  );
}
